import { useEffect, useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const normalizeSystemNameList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.systemNameList)) return payload.systemNameList;
  if (Array.isArray(payload?.system_name_list)) return payload.system_name_list;
  return [];
};

const useSystemNamesList = () => {
  const [systemNameList, setsystemNameList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSNList = async () => {
      try {
          const { data } = await axiosApi.get('/nisMasterlist/systemNames');
          setsystemNameList(normalizeSystemNameList(data));
      } catch (err) {
        console.error('Error fetching System Names list:', err);
        setError('Failed to load System Names list');
      } finally {
        setLoading(false);
      }
    };

    fetchSNList();
  }, []);

  return { systemNameList, loading, error };
};

export default useSystemNamesList;